<script>
export default {
    created() {},
    props: {
        handlerCodeSearch: {
            type: Function,
            required: true,
        },
        searchQuery: {
            type: Object,
            required: true,
        },
        selectOption: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        reset() {
            this.$clearObject(this.searchQuery);
        },
        add() {
            this.$emit("add");
        },
        change(value, type) {
            this.$emit("change", { value, type });
        },
    },
    components: {},
};
</script>
<template>
    <div class="name-search">
        <el-row :gutter="20">
            <el-col :span="6">
                <el-input
                    v-model.trim="searchQuery.custName"
                    @change="change($event, 'custName')"
                    placeholder="公司名称"
                ></el-input>
            </el-col>
            <el-col :span="6">
                <el-select
                    v-model="searchQuery.custType"
                    class="common-width"
                    placeholder="公司类型"
                    @change="change($event, 'custType')"
                >
                    <el-option
                        v-for="item in selectOption.custType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                <el-input
                    v-model.trim="searchQuery.creditCode"
                    @change="change($event, 'creditCode')"
                    placeholder="统一社会信用编码"
                ></el-input>
            </el-col>
            <el-col :span="6">
                <el-button type="primary" @click="handlerCodeSearch"
                    >搜索</el-button
                >
                <el-button type="primary" @click="reset">重置</el-button>
                <el-button type="primary" @click="add">新增</el-button>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%
</style>
